import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'

// --- Firebase
import "@/helpers/firebaseConf"
import firebase from "firebase/app";
import "firebase/auth";

// --- Globals
Vue.use(VueRouter)

// --- Components
import Index from '@/components/Index'
import Login from '@/components/Login'

// --- Router
const routes = [
  { path: '/kirjaudu-sisaan', component: Login, name: 'login' },
  { path: '/', component: Index, name: 'index' }
]

// --- Init Vue Router
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

// --- Before each route
router.beforeEach( (to, from, next) => {

  firebase.auth().onAuthStateChanged(function(user) {

    if( !user && to.name != "login" ) next({ path: "/kirjaudu-sisaan"} )
    else next()

  })

})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
